import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  financialYears,
  leadershipFilterData,
  projectDetails,
  projectList,
} from './api';
import { message } from 'antd';

const initialState = {
  projectDetails: null,
  projectDetailsLoading: false,
  filteredData: [],
  filteredDataLoading: false,
  financialYearsData: [],
  financialYearsLoading: false,
};

const actions = {
  PROJECT_DETAILS: 'PROJECT_DETAILS',
  FILTERED_DATA: 'FILTERED_DATA',
  FINANCIAL_YEARS: 'FINANCIAL_YEARS',
};

export const getProjectDetails = createAsyncThunk(
  actions.PROJECT_DETAILS,
  async (payload) => {
    const response = await projectDetails(payload);
    return response;
  },
);

export const getFilteredData = createAsyncThunk(
  actions.FILTERED_DATA,
  async (payload) => {
    const response = await leadershipFilterData(payload);
    return response;
  },
);

export const getFinancialYears = createAsyncThunk(
  actions.FINANCIAL_YEARS,
  async (payload) => {
    const response = await financialYears(payload);
    return response;
  },
);

export const advanceSearchSlice = createSlice({
  name: 'advanceSearch',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getProjectDetails.pending, (state) => {
        state.projectDetailsLoading = true;
      })
      .addCase(getProjectDetails.fulfilled, (state, action) => {
        state.projectDetailsLoading = false;

        if (action.payload.success) {
          state.projectDetails = action.payload.data;
        }
      })
      .addCase(getProjectDetails.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.projectDetailsLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getFilteredData.pending, (state) => {
        state.filteredDataLoading = true;
      })
      .addCase(getFilteredData.fulfilled, (state, action) => {
        state.filteredDataLoading = false;

        if (action.payload.success) {
          state.filteredData = action.payload.project_list;
        }
      })
      .addCase(getFilteredData.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.filteredDataLoading = false;
        message.error(msg);
      });
    builder
      .addCase(getFinancialYears.pending, (state) => {
        state.financialYearsLoading = true;
      })
      .addCase(getFinancialYears.fulfilled, (state, action) => {
        state.financialYearsLoading = false;

        if (action.payload.success) {
          state.financialYearsData = action.payload.year_list;
        }
      })
      .addCase(getFinancialYears.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.financialYearsLoading = false;
        message.error(msg);
      });
  },
});

export default advanceSearchSlice.reducer;
